import {
  LogoSection,
  LogoContainer,
  LogoDesc,
  LogoBox,
  Footer,
  FooterContent,
  FooterGrid,
  FooterLink,
  FooterLinkList,
  Copyright} from './styles/Footer.styles';
import Logo from 'static/images/logo.png';
import { Link } from 'react-router-dom';
export default function FooterSection() {
  return (
    <Footer>
      <FooterContent>
        <FooterGrid>
          <LogoSection>
            <LogoContainer>
              <LogoBox>
                <img src={Logo} alt="" />
              </LogoBox>
            </LogoContainer>
          </LogoSection>
          <div className="footer-middle">
            <LogoDesc>
              AI for Film & Television Professionals{' '}
              <Copyright>© Full Frame - All rights reserved.</Copyright>{' '}
            </LogoDesc>
          </div>
          <div>
            <FooterLinkList>
              <FooterLink>
                <Link to="/terms-of-use-public">Terms of Use</Link>
              </FooterLink>
              <FooterLink>
                <Link to="/privacy-policy-public" href="#">
                  Privacy Policy
                </Link>
              </FooterLink>
            </FooterLinkList>
          </div>
        </FooterGrid>
      </FooterContent>
    </Footer>
  );
}
